module.exports = __webpack_public_path__ + "static/media/gaceta.c75d2c3b.svg";